import Column from '@components/column'
import Fields from '@components/fields'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import {
  styleHalfWrapper,
  styleRow,
  styleRowInputWrapper,
  styleDropdownOptionsWrapper,
  styleDropdownInput,
} from './style'
import Row from '@components/row'
import Button from '@components/button'
import { PromoSchema } from '@validations'
import { Promo } from '@apis'
import { useLocation, useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
const initial = {
  title: '',
  category: '',
  startDate: '',
  endDate: '',
  code: '',
  discountAmount: '',
  discountType: '',
  userLimit: '',
  userType: '',
  isActive: false,
}
const PromoForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [initialValues, setInitialValues] = useState(initial)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values, { resetForm }) => {
    const payload: any = {
      title: values?.title,
      category: values?.category,
      code: values?.code,
      startDate: values?.startDate,
      endDate: values?.endDate,
      isActive: values?.isActive,
      userType: values?.userType,
      infos: {
        userLimit: values?.userLimit,
        discountType: values?.discountType,
        discountAmount: values?.discountAmount,
      },
    }
    setLoading(true)
    if (state?.id) {
      await Promo.update({
        id: state?.id,
        data: payload,
      })
        .then(() => {
          navigate('/admin/settings/marketing-settings?tab=promos')
        })
        .catch(() => {})
    } else {
      await Promo.create({
        data: payload,
      })
        .then(() => {
          resetForm()
        })
        .catch(() => {})
    }

    setLoading(false)
  }
  useEffect(() => {
    if (state?.id) {
      setInitialValues({
        title: state?.title,
        category: state.category,
        code: state.code,
        startDate: format(state?.startDate, 'yyyy-MM-dd'),
        endDate: format(state?.endDate, 'yyyy-MM-dd'),
        isActive: state?.isActive,
        userType: state.userType,
        userLimit: state?.infos?.userLimit,
        discountType: state?.infos?.discountType,
        discountAmount: state?.infos?.discountAmount,
      })
    } else {
      setInitialValues(initial)
    }
  }, [state?.id])
  return (
    <Column bg="white" styleColumn="border-radius:12px;padding:15px;">
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
        validationSchema={PromoSchema.validationSchema}
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <Fields.ChooseButton
                  items={[
                    {
                      label: 'All Category',
                      value: 'All',
                    },
                    {
                      label: 'Appointment',
                      value: 'Appointment',
                    },
                    {
                      label: 'Medicine',
                      value: 'Medicine',
                    },
                    {
                      label: 'Lab Test',
                      value: 'LabTest',
                    },
                    {
                      label: 'Healthcare Service',
                      value: 'Healthcare',
                    },
                  ]}
                  multiple={false}
                  name="category"
                  valueAsKey="value"
                  titleAsKey="label"
                  label="Category"
                  styleFormWrapper={styleRowInputWrapper}
                />
                <Fields.Input
                  name="title"
                  label="Title"
                  placeholder="Enter Title"
                  styleWrapper={styleRowInputWrapper}
                />
                <Row styleRow={styleRow}>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.Input
                      name="code"
                      placeholder="Coupon Code"
                      styleWrapper={styleRowInputWrapper}
                      label="Coupon Code"
                    />
                  </Row>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.Switch
                      label="Status"
                      name="isActive"
                      styleWrapper={styleRowInputWrapper}
                    />
                  </Row>
                </Row>
                <Row styleRow={styleRow}>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.Input
                      type="number"
                      label="User Limit"
                      placeholder="No. of Users"
                      name="userLimit"
                      styleWrapper={styleRowInputWrapper}
                    />
                  </Row>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.GroupRadioBox
                      name="userType"
                      options={[
                        {
                          label: 'New',
                          value: 'New',
                        },
                        {
                          label: 'Existing',
                          value: 'Existing',
                        },
                        {
                          label: 'Both',
                          value: 'Both',
                        },
                      ]}
                      valueAsKey="label"
                      titleAsKey="value"
                      label="User Type"
                      styleWrapper={styleRowInputWrapper}
                    />
                  </Row>
                </Row>
                <Row styleRow={styleRow}>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.DropDown
                      name="discountType"
                      options={[
                        {
                          label: 'Percentage',
                          value: 'Percentage',
                        },
                        {
                          label: 'Flat',
                          value: 'Flat',
                        },
                      ]}
                      titleAsKey="label"
                      valueAsKey="value"
                      placeholder="Select Discount Type"
                      styleWrapper={styleRowInputWrapper}
                      label="Discount Type"
                      styleOptionsWrapper={styleDropdownOptionsWrapper}
                      styleInput={styleDropdownInput}
                    />
                  </Row>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.Input
                      type="number"
                      label="Discount Amount"
                      placeholder="Discount Amount"
                      name="discountAmount"
                      styleWrapper={styleRowInputWrapper}
                    />
                  </Row>
                </Row>

                <Row styleRow={styleRow}>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.Input
                      type="date"
                      name="startDate"
                      label="Start Date"
                      styleWrapper={styleRowInputWrapper}
                    />
                  </Row>
                  <Row styleRow={styleHalfWrapper}>
                    <Fields.Input
                      type="date"
                      name="endDate"
                      label="End Date"
                      styleWrapper={styleRowInputWrapper}
                    />
                  </Row>
                </Row>
                <Column alignItems="flex-end">
                  <Button
                    title="Save"
                    loading={loading}
                    height={45}
                    styleButton="padding:0px 50px;"
                    type="submit"
                  />
                </Column>
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default PromoForm
